import { render, staticRenderFns } from "./AuftragTable.vue?vue&type=template&id=4727fa56&scoped=true"
import script from "./AuftragTable.vue?vue&type=script&lang=js"
export * from "./AuftragTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4727fa56",
  null
  
)

export default component.exports